<div
  class="{{ mainButtonCSS }} filecss"
  (dragover)="onDragOver($event)"
  (drop)="onDropSuccess($event)"
  [ngClass]="{ disabled: isDisabled }"

>
  <div class="k-dropzone-hint" (click)="fileInput.click()">Drop Files or Click to Upload</div>
  <input
    id="{{ elementId }}"
    type="file"
    (change)="addFiles($event)"
    [multiple]="multipleAllowed"
    placeholder="Drop Files or Click to Upload"
    #fileInput
  />
</div>
